import ItemListCardFooterLink from './ItemListCardFooterLink';

/**
 * ItemListCardFooterLinks - Renders a list of footer links for ItemListCard
 * @param {object} props
 * @param {Array<{href: string, label: string, targetBlank?: boolean}>} props.links - Footer links
 * @returns {JSX.Element | null}
 */
function ItemListCardFooterLinks({ links = [] }) {
  if (links.length === 0) return null;

  return (
    <>
      {links.map((link) => (
        <ItemListCardFooterLink
          key={`${link.href}-${link.label}`}
          href={link.href}
          label={link.label}
          targetBlank={link.targetBlank}
        />
      ))}
    </>
  );
}

export default ItemListCardFooterLinks;
